import { render } from "./Analytics_dashboard.vue?vue&type=template&id=52fdb0de&ts=true"
import script from "./Analytics_dashboard.vue?vue&type=script&lang=ts"
export * from "./Analytics_dashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__